import { apiFetch, toQuery } from './client';
import type { AdminUser, DailyActivity, LoginEvent, Paginated, Project } from '$lib/types';

export const adminUsersApi = {
  list: (params?: { q?: string; page?: number; per_page?: number }) =>
    apiFetch<Paginated<AdminUser>>(`/admin/users${toQuery(params)}`),
  create: (body: Record<string, unknown>) =>
    apiFetch<AdminUser>('/admin/users', { method: 'POST', body: JSON.stringify(body) }),
  update: (id: number, body: Record<string, unknown>) =>
    apiFetch<AdminUser>(`/admin/users/${id}`, { method: 'PUT', body: JSON.stringify(body) }),
  remove: (id: number) => apiFetch<{ detail: string }>(`/admin/users/${id}`, { method: 'DELETE' }),
  resetTotp: (id: number) =>
    apiFetch<{ detail: string }>(`/admin/users/${id}/reset-totp`, { method: 'POST' }),
  resetPassword: (id: number) =>
    apiFetch<{ detail: string; temp_password: string }>(`/admin/users/${id}/reset-password`, {
      method: 'POST'
    })
};

export const adminLoginsApi = {
  forUser: (id: number, params?: { page?: number; per_page?: number }) =>
    apiFetch<Paginated<LoginEvent>>(`/admin/users/${id}/logins${toQuery(params)}`),
  recent: (params?: { limit?: number }) =>
    apiFetch<{ results: LoginEvent[] }>(`/admin/logins${toQuery(params)}`)
};

// Admin-only cross-project daily digest. `date` is a YYYY-MM-DD day cut in
// Asia/Kolkata by the server (see $lib/utils/format#istDay); omitting it
// means "today in IST".
export const adminActivityApi = {
  daily: (date?: string) => apiFetch<DailyActivity>(`/admin/activity/daily${toQuery({ date })}`)
};

// Admin-only project CRUD. Member/admin *reads* go through projectsApi
// (see ./projects.ts) — GET /api/projects is scoped per-caller, this is the
// separate admin-only management surface.
export const adminProjectsApi = {
  list: () => apiFetch<{ results: Project[]; count: number }>('/admin/projects'),
  create: (body: Record<string, unknown>) =>
    apiFetch<Project>('/admin/projects', { method: 'POST', body: JSON.stringify(body) }),
  update: (id: number, body: Record<string, unknown>) =>
    apiFetch<Project>(`/admin/projects/${id}`, { method: 'PUT', body: JSON.stringify(body) }),
  remove: (id: number) => apiFetch<{ detail: string }>(`/admin/projects/${id}`, { method: 'DELETE' })
};
